import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'spMainImage' ]

  onChange(event) {
    if (this.hasSpMainImageTarget) {
      if (event.currentTarget.value == 'resort') {
        this.spMainImageTarget.classList.remove('is-hidden')
      } else {
        this.spMainImageTarget.classList.add('is-hidden')
      }
    }
  }
}
